import React, { useState, useEffect } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './MonthNavigator.css';

const MonthNavigator = ({ initialDate, onDateChange }) => {
  const [currentDate, setCurrentDate] = useState(() => {
    const [year, month] = initialDate.split('-').map(Number);
    return new Date(year, month - 1, 15);
  });

  useEffect(() => {
    const newDateString = currentDate.toISOString().slice(0, 7);
    onDateChange(newDateString);
  }, [currentDate, onDateChange]);

  const changeMonth = (amount) => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() + amount);
      return newDate;
    });
  };

  const formattedDate = currentDate.toLocaleString('pt-BR', {
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="month-navigator">
      <button onClick={() => changeMonth(-1)} className="nav-button" aria-label="Mês anterior" type="button">
        <LeftOutlined />
      </button>
      <span className="current-date">{formattedDate}</span>
      <button onClick={() => changeMonth(1)} className="nav-button" aria-label="Próximo mês" type="button">
        <RightOutlined />
      </button>
    </div>
  );
};

export default MonthNavigator;
